import { render, staticRenderFns } from "./FutureTrips.vue?vue&type=template&id=06da13b7&"
import script from "./FutureTrips.vue?vue&type=script&lang=js&"
export * from "./FutureTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports